export default "__VITE_ASSET__D8b5GNGc__"